"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _utilities = require("../../utilities");

var _default = function _default(displayName) {
  if (_utilities.configuration.current.styles.namespace) {
    return "".concat(_utilities.configuration.current.styles.namespace, "-").concat(displayName);
  }

  return displayName;
};

exports["default"] = _default;